<template>
<!-- Category -->
<div class="container mt-1">
    <div class="row">
      <div class="col text-center" style="background:#f3f4f6;padding-top:15px;padding-bottom:15px;">
        <h4 class="title text-success">御燕玺礼 燕窝</h4>
      </div>
    </div>
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
      <div class="col" v-for="item in items" :key="item.item_code">
          <Item :key="item.item_code" :item_code="item.item_code" :item_name="item.item_name" :unit="item.unit" :price="item.price" :weight="item.weight" :pic="item.pic"></Item>
      </div>
    </div>
</div>
</template>
<script>
  import { onMounted } from 'vue'
  import Item from '@/views/Item.vue'
  import axios from 'axios'
  export default {
    name: 'Category',
    
    components:{Item},
    emits: ['viewLoaded'],
    setup(props,ctx) {

        const items = [
          {
            item_name: "燕盏 (Bird Nest Oval)",
            item_code: 'IBN00OVMY01',
            price: 235,
            unit:  '50克/盒',
            weight: '1.764 oz',
            pic: require('../assets/products/default2.jpg')
          },
          {
            item_name: "燕盏 (Bird Nest Oval)",
            item_code: 'IBN00OVMY01',
            price: 1950,
            unit:  '50克/盒 10盒/箱',
            weight: '17.64 oz',
            pic: require('../assets/products/default2.jpg')
          },
          /*
          {
            item_name: "大燕条 (Big Broken bird Nest)",
            item_code: 'IBN00BBMY01',
            price: 1950,
            unit:  '500克/盒',
            weight: '17.64 oz',
            pic: require('../assets/products/default.jpg')
          },
          */
          {
            item_name: "燕碎 (Heart Shape Crushed Bird Nest)",
            item_code: 'IBN00HSMY01',
            price: 1500,
            unit:  '500克/盒',
            weight: '17.64 oz',
            pic: require('../assets/products/default2.jpg')
          },
          {
            item_name: "燕碎 (Heart Shape Crushed Bird Nest)",
            item_code: 'IBN00HSMY02',
            price: 1500,
            unit:  '500克/盒',
            weight: '17.64 oz',
            pic: require('../assets/products/default.jpg')
          }
        ]

        onMounted(() => {
          ctx.emit('viewLoaded','category')


          //test
          axios
            .post('http://localhost:8088/api/login',{username:'michael', password:'111111'})
            .then(function(response){
              console.log(response)
            })
            .catch(function (error) { // 请求失败处理
              console.log(error);
          });

        })
        return { items }
    }
  };
</script>
<style lang="scss" scoped>

</style>